import React from "react";

import SweetAlert from "react-bootstrap-sweetalert";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import CustomInput from "components/CustomInput/CustomInput.jsx";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Button from "components/CustomButtons/Button.jsx";

import ToolTipIcon from "views/Components/ToolTipIcon"

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import { verifyDecimal } from "../../assets/helpers/formHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle.jsx";
import {
  createTheme,
  MuiThemeProvider,
  withStyles
} from "@material-ui/core/styles";
const toolTipTheme = createTheme({
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "12px"
      }
    }
  }
});
const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  exampleTrack: {
    color: 'red'
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle,
  ...sweetAlertStyle,
  ...tasksStyle
};
// ];

class MembershipModel extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')

    this.state = {
      userId: userId,
      fees: [{ code: 'loading...', fee: 'loading...', freq: ''}],
      discount: 0,
      monthlyFee: 'loading...',
      feeFreqOptions: [],
      inputDisabled: true,
      submitMembershipButtonDisabled: false,
      alert: null,
      patientShare: 0,
      memberDiscount: 0,
      loyaltyBonus: 0,
      entityId: '',
      entityList: []
    };

  }
  componentDidMount() {
    this._isMounted = true;
    this.getEntities()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.allFinancials !== this.props.allFinancials) {
      this.getEntities()
    }
  }


  getMembershipInfo() {
    axios.get(`${API_ROOT}/practiceSystem/membership/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setMembershipInfo(res.data));
  }

  setMembershipInfo(res) {
    if (!res.error) {
      var patientShare;
      var memberDiscount;
      var loyaltyBonus;
      var entityId;
      res.patientShare ? patientShare = res.patientShare * 100 : patientShare = 0
      res.memberDiscount ? memberDiscount = res.memberDiscount * 100 : memberDiscount = 0
      res.loyaltyBonus ? loyaltyBonus = res.loyaltyBonus * 100 : loyaltyBonus = 0
      res.entityId ? entityId = res.entityId : entityId = ''

      this.setState({
        patientShare: patientShare,
        memberDiscount: memberDiscount,
        loyaltyBonus: loyaltyBonus,
        entityId: entityId,
        inputDisabled: false
      })
      if (res.patientShare && res.memberDiscount && res.loyaltyBonus) {
        this.getModeledFinancials()
      }
    }
  }

  getEntities() {
    axios.get(`${API_ROOT}/practiceSystem/entities/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setEntities(res.data));
  }

  setEntities(res) {
    if (!res.error) {
      this.setState({
        entityList: res
      }, this.getMembershipInfo())
    }
  }


  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }


  handleChangeSelect = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  onSubmitMembership() {
    var validParams = true
    if (this.state.patientShare === '' || !verifyDecimal(this.state.patientShare)) {
      validParams = false
    } else if (this.state.memberDiscount === '' || !verifyDecimal(this.state.memberDiscount)) {
      validParams = false
    } else if (this.state.loyaltyBonus === '' || !verifyDecimal(this.state.loyaltyBonus)) {
      validParams = false
    }

    if (!validParams) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="entry warning"
            onConfirm={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            confirmBtnText="okay"
          >
            Please enter only numbers in the % patients, member discount and loyalty bonus fields.
          </SweetAlert>
        )
      });
    } else {
      const membershipData = {
        patientShare: this.state.patientShare / 100,
        memberDiscount: this.state.memberDiscount / 100,
        loyaltyBonus: this.state.loyaltyBonus / 100,
        entity: this.state.entityId
      }
      const postData = {
        userId: this.state.userId,
        membership: JSON.stringify(membershipData)
      }
      axios.post(`${API_ROOT}/practiceSystem/membership/`, postData, { headers: getApiHeaders() })
        .then(res => this.handleSubmitMembership(res.data));
    }
  }

  handleSubmitMembership(res) {
    if (res.status && res.status === 'success') {
      this.getModeledFinancials()
    }
  }

  getModeledFinancials() {

    axios.get(`${API_ROOT}/practiceSystem/membership/?userId=`+this.state.userId+`&returnAnalytics=true`, {headers: getApiHeaders()})
      .then(res => this.setModeledFinancials(res.data));
  }

  setModeledFinancials(res) {
    if (this.props.updateCharts) {
      this.props.updateCharts(res)
    }
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', align: 'center', height: '100%'}}>
        <GridContainer>
          {this.state.alert}
          <GridItem xs={12} sm={12}>
            Enter the basic parameters for your membership program, and we'll show you how your office finances will improve.
            <hr />
          </GridItem>



          <GridItem xs={12} sm={7} md={7}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <CustomInput
                  labelText="% patients"
                  type="text"
                  id="patientShare"
                  inputProps={{
                    onChange: this.handleChange,
                    value: this.state.patientShare,
                    disabled: this.state.inputDisabled,
                    endAdornment: (
                      <div>
                        <MuiThemeProvider theme={toolTipTheme}>
                          <ToolTipIcon
                            placement="top"
                            tooltipText='Most practices aim to enroll about 5% of their patients during the first year of the
                            membership program. If you plan to be more proactive educating patients about your membership
                            program, feel free to set a higher percentage for your estimates.'
                            classes={{ tooltip: classes.tooltip }}
                            displayTextPrefix='%'
                          />
                        </MuiThemeProvider>
                      </div>
                    )
                  }}
                />
              </GridItem>


              <GridItem xs={12} sm={12} md={12}>
                <FormControl
                  fullWidth
                  className={classes.selectFormControl}
                >
                  <InputLabel
                    htmlFor="simple-select"
                    className={classes.selectLabel}
                  >
                    targeted PPO
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    classes={{
                      select: classes.select
                    }}
                    value={this.state.entityId}
                    onChange={this.handleChangeSelect}

                    inputProps={{
                      id: "entityId",
                      name: "entityId",
                      disabled: this.state.inputDisabled

                    }}

                  >
                    <MenuItem
                      classes={{
                        root: classes.selectMenuItem
                      }}
                      value=""
                    >
                      all
                    </MenuItem>
                    {this.state.entityList.map((entity) =>
                      <MenuItem classes={{
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected
                      }} key={entity.id} value={entity.id} >{entity.entity}</MenuItem>
                    )}

                  </Select>
                </FormControl>
              </GridItem>
              {/*MAY ADD BELOW SECTION BACK AT A LATER TIME*/}
              {/*<GridItem xs={12} sm={12} md={12}>*/}
                {/*<CustomInput*/}
                  {/*labelText="member discount"*/}
                  {/*type="text"*/}
                  {/*id="memberDiscount"*/}
                  {/*inputProps={{*/}
                    {/*onChange: this.handleChange,*/}
                    {/*value: this.state.memberDiscount,*/}
                    {/*disabled: this.state.inputDisabled,*/}
                    {/*endAdornment: (*/}
                      {/*<div>*/}
                        {/*<MuiThemeProvider theme={toolTipTheme}>*/}
                          {/*<ToolTipIcon*/}
                            {/*placement="top"*/}
                            {/*tooltipText='A discount is a good way to entice patients to sign up for your membership program.*/}
                            {/*And it is important to view a discount as what it is - it exchange for a slight reduction in prices,*/}
                            {/*you get regular payments from patients, and the patients are more loyal to your office.*/}
                            {/*Plus, any discount you offer will likely be far less than what the insurers discount your fees.*/}
                            {/*We suggest a 15% discount for members, but feel free to set whatever works best for your practice and patients.'*/}
                            {/*classes={{ tooltip: classes.tooltip }}*/}
                            {/*displayTextPrefix='%'*/}
                          {/*/>*/}
                        {/*</MuiThemeProvider>*/}
                      {/*</div>*/}
                    {/*)*/}
                  {/*}}*/}
                {/*/>*/}
              {/*</GridItem>*/}
              {/*<GridItem xs={12} sm={12} md={12}>*/}
                {/*<CustomInput*/}
                  {/*labelText="loyalty bonus"*/}
                  {/*type="text"*/}
                  {/*id="loyaltyBonus"*/}
                  {/*inputProps={{*/}
                    {/*onChange: this.handleChange,*/}
                    {/*value: this.state.loyaltyBonus,*/}
                    {/*disabled: this.state.inputDisabled,*/}
                    {/*endAdornment: (*/}
                      {/*<div>*/}
                        {/*<MuiThemeProvider theme={toolTipTheme}>*/}
                          {/*<ToolTipIcon*/}
                            {/*placement="top"*/}
                            {/*tooltipText='Patients who are members of your office are more loyal. And this means they are*/}
                            {/*more likely than other patients to follow through with the treatment you recommend.*/}
                            {/*Because of this, we suggest adding a loyalty bonus to your membership projections.*/}
                            {/*This lets you account for the increased case acceptance - and increased revenue - from*/}
                            {/*patients who are members. We suggest 20% as a conservative estimate of the boost in case*/}
                            {/*acceptance and revenue you will see from members.'*/}
                            {/*classes={{ tooltip: classes.tooltip }}*/}
                            {/*displayTextPrefix='%'*/}
                          {/*/>*/}
                        {/*</MuiThemeProvider>*/}
                      {/*</div>*/}
                    {/*)*/}
                  {/*}}*/}
                {/*/>*/}
              {/*</GridItem>*/}
              <GridItem xs={12} sm={12} md={12}>
                <Button
                  onClick={this.onSubmitMembership.bind(this)}
                  color="cirrusBlue"
                  id="submitMembershipButton"
                  disabled={this.state.inputDisabled}
                  >
                  update membership info and show results
                </Button>
              </GridItem>
           </GridContainer>
          </GridItem>
        </GridContainer>
      </div>

    );
  }
}

export default withStyles(style)(MembershipModel);
